import type { SourceReaderFunction } from '@festina-life/core'
import * as Yup from 'yup'

import type { translations } from '../../../../translations/translations'
import { type AnyDateVFrame, isRangeVFrame } from './types'

export const dateValidation = (
  frame: AnyDateVFrame,
  translate: SourceReaderFunction<(typeof translations)['en-GB']>,
) => {
  let yupDate = Yup.date()

  const [min, max] = isRangeVFrame(frame)
    ? [frame.min, frame.max]
    : [undefined, undefined]

  // `notEmpty` is not used because `min` and `max` could be empty strings.
  // Unlike the falsey number 0, empty strings are not valid bounds.
  const minMaxMessage =
    min && max
      ? translate('validation.between', {
          max,
          min,
        })
      : undefined

  if (min) {
    yupDate = yupDate.min(
      min,
      minMaxMessage ??
        translate('validation.min', {
          min,
        }),
    )
  }

  if (max) {
    yupDate = yupDate.max(
      max,
      minMaxMessage ??
        translate('validation.max', {
          max,
        }),
    )
  }

  return yupDate
}
